import React from 'react';

const newContext = React.createContext();

export { newContext };